function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
},
/*#__PURE__*/
React.createElement("rect", {
  stroke: "#D3D3D3",
  fill: "#FFF",
  x: 0.5,
  y: 0.5,
  width: 35,
  height: 23,
  rx: 4
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M30.035 15.496c0-.24.193-.434.432-.434s.432.194.432.434-.193.435-.432.435a.434.434 0 01-.432-.435zm.432.33a.33.33 0 00.329-.33.329.329 0 10-.657 0c0 .183.147.33.328.33zm-.058-.139h-.089v-.382h.16c.034 0 .068 0 .098.02.03.021.048.057.048.095a.104.104 0 01-.066.099l.07.168h-.099l-.057-.151h-.065v.151zm0-.217h.048c.019 0 .038.002.055-.007a.053.053 0 00.022-.044.048.048 0 00-.022-.038c-.015-.01-.04-.008-.056-.008h-.047v.097z",
  fill: "#0161AB"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M4.216 8.073h-.003l.038-.136h3.293c.907 0 .991.722.991.722l.703 3.607s-.472-1.463-1.924-2.638C5.796 8.4 4.213 8.072 4.213 8.072l.038-.135h3.293c.907 0 .991.722.991.722l.703 3.607.236 1.188 1.992-5.517h2.25l-3.325 8.021H8.214L6.399 8.99c-1.142-.685-2.123-.903-2.183-.916h-.003l.038-.136h3.293c.907 0 .991.722.991.722l.703 3.607s-.472-1.463-1.924-2.638C5.834 8.431 4.293 8.09 4.216 8.073zM27.9 15.958l-.245-1.19H25l-.436 1.19h-2.177l3.115-7.424s.19-.597.965-.597h1.68l1.673 8.021H27.9zm-2.299-2.837h1.716l-.618-3.003-1.098 3.003zM22.55 9.866c-.894-.493-2.93-.61-2.93.297s2.917 1.102 2.917 3.187c0 2.008-2.152 2.747-3.577 2.747-1.426 0-2.359-.454-2.359-.454l.31-1.8c.856.686 3.449.88 3.449-.208s-2.89-1.113-2.89-3.186c0-2.203 2.462-2.656 3.499-2.656.959 0 1.879.35 1.879.35l-.298 1.723zm-7.237 6.092h-2.089l1.306-8.021h2.09l-1.307 8.021z",
  fill: "#343A8A"
}));

var SvgVisaCard = function SvgVisaCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 36 24",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgVisaCard, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/VisaCard.d260a3e5.svg";
export { ForwardRef as ReactComponent };